import { Fragment } from 'react';
import Display from "../display/Display";
import DisplayTotals from "../display/DisplayTotals";
import styled from "styled-components"
import { useStore } from "../pageView/Page";
import Tabs from "../tabs/Tabs";
import LineDocumentsButton from "../documents/LineDocumentsButton";

const PaperSheet = styled.div`
  background-color: ${({ theme }) => theme.page.background} ;
  box-shadow: ${({ theme }) => theme.page.shadow} ;/* Adjust shadow as needed */
  border-radius: 1rem; /* Gives a rounded corner effect */
  padding: 20px;
`;

const SectionBlock = styled.div`
  margin-bottom: 1rem;
`;

const LineRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.25rem;
`;

const LineMain = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;


const DisplayLines = ({ section, state }) => {
    const lines = state[section.displaySection.linesArray] || []
    const orderBy = section.displaySection.orderBy

    // Render order = original store indices, optionally sorted by a line field
    // (e.g. sortOrder). idx must stay the store index — Display reads
    // linesArray[idx] — so we reorder indices, not a copied array. Lines missing
    // the field sort last; ties keep original order (stable).
    let order = lines.map((_, i) => i)
    if (orderBy) {
        order = order.slice().sort((a, b) => {
            const va = lines[a]?.[orderBy]
            const vb = lines[b]?.[orderBy]
            const na = (va === undefined || va === null) ? Infinity : va
            const nb = (vb === undefined || vb === null) ? Infinity : vb
            return na === nb ? a - b : na - nb
        })
    }

    // A line with documents (`meta.lineDocuments`) keeps its button beside it.
    const lineDocuments = section.meta?.lineDocuments

    return order.map(
        (idx) => (
            <Fragment key={idx}>
                {lineDocuments
                    ? <LineRow>
                        <LineMain><Display type='lines' idx={idx} section={section} /></LineMain>
                        <LineDocumentsButton lineDocuments={lineDocuments} index={idx} />
                    </LineRow>
                    : <Display type='lines' idx={idx} section={section} />}
            </Fragment>
        )
    )
}



const DisplayViewDocument = ({ config }) => {
    const linesArrayKeys = config.sections
        .filter(s => s.displaySection.type === 'lines')
        .map(s => s.displaySection.linesArray)

    const [state] = useStore(s =>
        Object.fromEntries(linesArrayKeys.map(k => [k, s[k]]))
    )

    const renderSection = (section, i) => (
        <Fragment key={i}>
            {(section.displaySection.type === 'regular') &&
                <SectionBlock>
                    <Display type='root' section={section} />
                </SectionBlock>
            }
            {(section.displaySection.type === 'lines') &&
                <SectionBlock>
                    <DisplayLines section={section} state={state} />
                </SectionBlock>
            }
            {(section.displaySection.type === 'totals') &&
                <DisplayTotals section={section} />
            }
        </Fragment>
    )

    // Tabs (opt-in): when config.tabs is set, sections without a meta.tab render
    // above the tab bar (e.g. the header) and the rest are grouped into tabs.
    const tabbed = Array.isArray(config.tabs) && config.tabs.length > 0
    const headerSections = tabbed ? config.sections.filter(s => !s.meta?.tab) : config.sections
    const tabsConfig = tabbed ? config.tabs.map(tab => ({
        key: tab.key,
        label: tab.label,
        icon: tab.icon,
        content: <>{config.sections.filter(s => s.meta?.tab === tab.key).map(renderSection)}</>
    })) : []

    return (
        <PaperSheet>
            {headerSections.map(renderSection)}
            {tabbed && <Tabs config={tabsConfig} id={`display-${config.entity}`} type="" conditionValue={null} />}
        </PaperSheet>
    )

}

export default DisplayViewDocument
